<template>
  <div>
    <div class="lishi-0">
      <div class="lishi-1">
        <van-row type="flex">
          <van-col span="12">搜索历史</van-col>
          <van-col span="12" class="lishi-1-1" @click="deleteFun">删除</van-col>
        </van-row>
      </div>
      <div>
        <ul class="lishi-2">
          <li @click="wordFun(item)" v-for="(item,index) in list" :key="index">{{item}}</li>
        </ul>
      </div>
    </div> 
  </div>
</template>
<script>
import http from "@/utils/axios";
import BeeGoodsList from "@/views/beeAdministrate/components/list";
export default {
  name: "beeAdministrate-list-history",
  props: {},
  data() {
    return {
      list: [],
      visible: false
    };
  },
  methods: {
    init() {
      this.visible = false;
      http({
        url: "order/item/quick/bees/searchHistory",
        method: "get"
      })
        .then(rps => {
          this.list = rps.data;
        })
        .catch(rps => {});
    },
    deleteFun() {
      if (this.list.length == 0) {
        return;
      }
      this.$dialog
        .confirm({
          title: "",
          message: "确定删除历史记录吗?"
        })
        .then(() => {
          http({
            url: "order/item/quick/bees/clearSearchHistory",
            method: "DELETE"
          })
            .then(rps => {
              this.init();
            })
            .catch(rps => {});
        })
        .catch(() => {
          // on cancel
        });
    },
    wordFun(val) {
      this.$emit("BeeGoodsListCallback", val);
    }
  },
  created() {
    this.init();
  },
  computed: {},
  components: { BeeGoodsList }
};
</script>
<style lang="less" scoped>
.lishi-0 {
  margin-top: 50px;
  margin-left: 40px;
  margin-right: 33px;
  min-height: 100%;
  .lishi-1 {
    font-size: 26px;
    color: #333333;
    margin-bottom: 29px;
    .lishi-1-1 {
      color: #999999;
      font-size: 24px;
      text-align: right;
    }
  }
  .lishi-2 {
    display: flex;
    flex-wrap: wrap;
    align-items: left;
    li {
      color: #666;
      font-size: 0.32rem;
      font-weight: 500;
      margin: 0.13333rem 0.4rem 0 0;
      background: #f2f2f2;
      display: inline-block;
      padding: 0.16rem 0.4rem;
      border-radius: 0.66667rem;
    }
  }
}
.vid {
  padding-left: 30px;
  padding-right: 30px;
}
</style>
